<template>
  <div id="layout-base">
    <topbar>
      <template #topbar>
        <slot name="topbar"/>
      </template>
    </topbar>
    <div id="main">
      <sidebar-left>
        <template #sidebar-left>
          <slot name="sidebar-left"/>
        </template>
      </sidebar-left>
      <main-canvas>
        <template #main-canvas>
          <slot name="secondary-nav"/>
          <slot name="main-canvas-ad"/>
          <slot name="main-canvas"/>
        </template>
      </main-canvas>
      <sidebar-right>
        <template #sidebar-right>
          <slot name="sidebar-right"/>
        </template>
      </sidebar-right>
    </div>
  </div>
</template>
<script>
import store from './../mixins/store.mixin'
import Topbar from "./components/Topbar.vue";
import SidebarRight from "./components/SidebarRight.vue";
import SidebarLeft from "./components/SidebarLeft.vue";
import MainCanvas from "./components/MainCanvas.vue";

export default {
  name: "BaseLayout",
  props: {},
  components: {
    Topbar,
    SidebarRight,
    MainCanvas,
    SidebarLeft,
  },
  mixins: [
    store,
  ],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {},
  computed: {}
};
</script>
<style lang="scss" scoped>
#main {
  display: flex;
  height: calc(100% - 40px);
  border-top: 1px solid #CBCBCB;

  .dark-mode & {
    border-top: 1px solid #595959;
  }

  overflow: hidden;
}

#layout-base {
  height: 100%;
  background: yellow;
}


</style>
